import React from 'react';

import Icon, { type IconSize } from '../Icon/Icon';
import { spinnerStyles } from './Spinner.styles';

export type SpinnerProps = {
  /**
   * Size of the spinner using IconSize tokens
   */
  size?: IconSize;
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Fill color for the spinner
   */
  fill?: string;
};

const Spinner = ({ size = 'medium', className, fill }: SpinnerProps) => {
  return (
    <Icon
      variant="Spinner"
      size={size}
      className={className}
      css={spinnerStyles}
      fill={fill}
    />
  );
};

export default Spinner;
